export const PROPERTY_TABLE_QUERIES_KEY = {
  id: 'id.equals',
  generalLabourName: 'generalLabourName.contains',
  projectManager: 'projectManager.contains',
  projectStatus: 'projectStatus.in',
  streetAddress: 'streetAddress.contains',
  city: 'city.contains',
  clientStartDate: 'clientStartDate.equals',
  clientDueDate: 'clientDueDate.equals',
  projectTypeLabel: 'projectTypeLabel.contains',
  projectCoordinator: 'projectCoordinator.contains',
  accountPayable: 'accountPayable.equals',
  zipCode: 'zipCode.contains',
  clientName: 'clientName.contains',
  sowOriginalContractAmount: 'sowOriginalContractAmount.equals',
  projectRelatedCost: 'projectRelatedCost.equals',
  woaPaidDate: 'woaPaidDate.equals',
  invoiceNumber: 'invoiceNumber.contains',
  woaInvoiceDate: 'woaInvoiceDate.equals',
  accountRecievable: 'accountRecievable.equals',
  market: 'market.contains',
  state: 'state.contains',
  woaCompletionDate: 'woaCompletionDate.equals',
  region: 'region.contains',
  partialPayment: 'partialPayment.equals',
  expectedPaymentDate: 'expectedPaymentDate.equals',
  profitPercentage: 'profitPercentage.equals',
  profitPercentageAmount: 'profitPercentageAmount.greaterThanOrEqual',
  profitTotal: 'profitTotal.equals',
  materialCost: 'materialCost.equals',
  drawAmount: 'drawAmount.equals',
  vendorPaymentPercentage: 'vendorPaymentPercentage.equals',
  woNumber: 'woNumber.contains',
  poNumber: 'poNumber.contains',
  pastDue: 'pastDue.equals',
  projectManagerId: 'projectManagerId.in',
  projectStatusId: 'projectStatusId.in',
  clientSignoffDate: 'clientSignoffDate.lessThanOrEqual',
  sowNewAmount: 'sowNewAmount.equals',
  drawAmountSow: 'drawAmountSow.equals',
  drawAmountWo: 'drawAmountWo.equals',
  disqualifiedRevenueFlag: 'disqualifiedRevenueFlag.equals',
  unitNo: "unitNo.contains"
}

